export const LAST_PERSPECTIVE_USER_SETTINGS_KEY = 'console.lastPerspective';
export const LAST_PERSPECTIVE_LOCAL_STORAGE_KEY = `bridge/last-perspective`;
export const HIDE_USER_WORKLOAD_NOTIFICATIONS_USER_SETTINGS_KEY =
  'console.hideUserWorkloadNotifications';
export const FLAG_DEVELOPER_PERSPECTIVE = 'DEVELOPER_PERSPECTIVE';
export const ACM_PERSPECTIVE_ID = 'acm';
export const ADMIN_PERSPECTIVE_ID = 'admin';
